/**
 *  Время в секундах
 */

export const STORY_TIME = 3.5;

export const DESCRIPTION = 'Get yourself in the mood every day with a large collection of 4k and 5k wallpapers.';
